/**
 * @Author: mojeujun
 * @Date: 2025-06-19 14:54:30
 * @Explain: axios nest后端接口 - 统一处理
 */
import type { AxiosInstance } from 'axios';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import {
  beforeReqTimeMark,
  onResError,
  onResSuccess,
  setReqConfig,
} from './interfaceUtils';
// smlMonitor
import { smlMonitor } from '@/utils/smlMonitor';
// utils
import { API } from '@/config';
import { BooleanTypeEnum } from '@/definition/common/data.d';
class AxiosService {
  public axiosInstance: AxiosInstance;

  constructor() {
    this.axiosInstance = axios.create({
      baseURL: API.nestApiPrefile,
      timeout: 20 * 1000, // 20S
    });
    this.setInterceptorsReq();
    this.setInterceptorsRes();
  }
  // 添加拦截器
  private setInterceptorsReq = () => {
    this.axiosInstance.interceptors.request.use(
      (config) => {
        // 请求前配置 记录请求
        const key = `${config.url}-${uuidv4()}`;
        config.designReportKey = key;
        config[beforeReqTimeMark] = new Date().valueOf();
        if (!config.params) {
          config.params = {};
        }
        config.params.isPackage = BooleanTypeEnum.N;
        config.params.noGetUrl = true;
        smlMonitor?.setNetworkInfo(key, true);
        const newConfig = setReqConfig(config);
        Reflect.deleteProperty(newConfig.params, 'noGetUrl');
        Reflect.deleteProperty(newConfig.params, 'isPackage');
        return newConfig;
      },
      (error) => {
        // 异常时 删除
        smlMonitor?.delNetworkCount(error?.config?.designReportKey);
        console.error('request.use', error);
        return Promise.reject(error);
      },
    );
  };

  private setInterceptorsRes = () => {
    this.axiosInstance.interceptors.response.use(
      (response) => {
        // 完成时 删除
        smlMonitor?.delNetworkCount(response?.config?.designReportKey);
        return onResSuccess(response);
      },
      (error) => {
        // 异常时 删除
        smlMonitor?.delNetworkCount(error?.config?.designReportKey);
        const config: any = error?.config;
        // 是否弹出error提示框拦截
        const unUseCommonMsg = config?.params?.unUseCommonMsg;
        if (!unUseCommonMsg) onResError(error, true);
        return Promise.reject(error);
      },
    );
  };
}

export default new AxiosService().axiosInstance;
